import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Table } from 'antd';
import { getChildrenToRender, isImg } from './utils';

class Pricing2 extends React.PureComponent {
  getColumns = (columns) => {
    return columns.map((item) => {
      const { childWrapper, ...$item } = item;
      return {
        align: 'center',
        ...$item,
        title: (
          <div {...childWrapper}>
            {childWrapper.children.map(getChildrenToRender)}
          </div>
        ),
      };
    });
  };

  getDataSource = (dataSource, columns) =>
    dataSource.map((item, i) => {
      const obj = { key: i.toString() };
      item.children.forEach(($item, ii) => {
        if (columns[ii]) {
          obj[columns[ii].key] = (
            <div {...$item}>
              {typeof $item.children === 'string' &&
              $item.children.match(isImg) ? (
                <img src={$item.children} alt="img" />
              ) : (
                $item.children
              )}
            </div>
          );
        }
      });
      return obj;
    });

  // 保留原函数，但我们会只在确实存在 name 列时才使用
  getMobileChild = (table) => {
    const { columns, dataSource, ...tableProps } = table;
    const names = columns.children.filter(
      (item) => (item.key || '').indexOf('name') >= 0 ||
                (item.dataIndex || '').indexOf('name') >= 0
    );
    const newColumns = columns.children.filter(
      (item) => (item.key || '').indexOf('name') === -1 &&
                (item.dataIndex || '').indexOf('name') === -1
    );
    return newColumns.map((item, i) => {
      const items = [].concat(names[0], item).filter((c) => c);
      if (items.length > 1) {
        items[0].colSpan = 0;
        items[1].colSpan = 2;
      }
      const dataSources = dataSource.children.map(($item) => {
        const child = $item.children.filter(
          (c) => c.name.indexOf('name') === -1
        );
        const n = $item.children.filter((c) => c.name.indexOf('name') >= 0);
        return {
          ...$item,
          children: [].concat(n[0], child[i]).filter((c) => c),
        };
      });
      const props = {
        ...tableProps,
        columns: this.getColumns(items),
        dataSource: this.getDataSource(dataSources, items),
      };
      return (
        <Table key={i.toString()} {...props} pagination={false} bordered />
      );
    });
  };

  render() {
    const { dataSource, isMobile, ...props } = this.props;
    const { Table: table, wrapper, page, titleWrapper } = dataSource;
    const { columns, dataSource: tableData, ...$table } = table;

    // NEW: 统一生成列与数据
    const baseColumns = this.getColumns(columns.children);
    const baseData = this.getDataSource(tableData.children, columns.children);

    // NEW: 仅当确有 name 列时才走“拆表”逻辑，否则一律用同一张表 + 横向滚动
    const hasNameCol = columns.children.some(
      (c) =>
        (c.key && c.key.includes('name')) ||
        (c.dataIndex && c.dataIndex.includes('name'))
    );

    // NEW: 移动端加上 scroll.x 与 size="small"
    const baseTable = (
      <Table
        key="table"
        {...$table}
        columns={baseColumns}
        dataSource={baseData}
        pagination={false}
        bordered
        size={isMobile ? 'small' : undefined}
        scroll={isMobile ? { x: 'max-content' } : undefined}
      />
    );

    const childrenToRender = isMobile && hasNameCol
      ? this.getMobileChild(table)
      : baseTable;

    return (
      <div {...props} {...wrapper}>
        <div {...page}>
          <div key="title" {...titleWrapper}>
            {titleWrapper.children.map(getChildrenToRender)}
          </div>
          {/* <OverPack {...dataSource.OverPack}> */}
            <QueueAnim
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInOutQuad']}
              key="content"
            >
              {childrenToRender}
            </QueueAnim>
          {/* </OverPack> */}
        </div>
<style>{`
  /* 只在手机端清理多余空白 */
  @media (max-width: 768px) {
    /* 1) 强制该区块及其内层 page 取消固定高度/最小高度 */
    #Pricing2_0 {
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
    }
    #Pricing2_0 .home-page,
    #Pricing2_0 .home-page > * {
      height: auto !important;
      min-height: 0 !important;
    }

    /* 2) OverPack/QueueAnim 在部分模板里会留出占位：把可见性外的占位压扁 */
    #Pricing2_0 .rc-overpack,
    #Pricing2_0 .rc-scroll-anim,
    #Pricing2_0 .queue-anim-leaving {
      height: auto !important;
      min-height: 0 !important;
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }
    /* 离场动画节点不占位（防止“看不见的最后一块”撑高） */
    #Pricing2_0 .queue-anim-leaving { display: none !important; }

    /* 3) 常见尾部来源：列表/表格及其容器的底边距 */
    #Pricing2_0 .content-wrapper,
    #Pricing2_0 .block-wrapper,
    #Pricing2_0 .table-wrapper,
    #Pricing2_0 .ant-table-wrapper,
    #Pricing2_0 .ant-table,
    #Pricing2_0 ul,
    #Pricing2_0 ol {
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }

    /* 4) 最后一项清零，防止最后一个子块的外边距塌陷形成“尾巴” */
    #Pricing2_0 > *:last-child,
    #Pricing2_0 .home-page > *:last-child,
    #Pricing2_0 .content-wrapper > *:last-child {
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }

    /* 5) 兜底：凡是内联写了 min-height 的，统统归零（少见但致命） */
    #Pricing2_0 [style*="min-height"] {
      min-height: 0 !important;
    }
  }
`}</style>
      </div>
    );
  }
}

export default Pricing2;
